<template>
<div>
  <v-btn v-if="params.show(params)" icon @click.native="clickHandler()">
      <v-icon color="var(--v-resBlue-darken1)">{{icon}}</v-icon>
  </v-btn>
</div>
</template>

<script>
  export default {
    name: 'GroupedRowButton',
    computed: {
      icon() {
        return this.params.allCollapsed(this.params) ? 'mdi-chevron-right' : 'mdi-chevron-down';
      }
    },
    methods: {
      clickHandler: function () {
        this.params.onClick(this.params);
      }
    }
  }
</script>

<style scoped lang="scss">
</style>
